var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D2DF",
    fillRule: "evenodd",
    d: "M30 22.5c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM21 12V9c0-1.656 1.344-3 3-3h12c1.656 0 3 1.344 3 3v3H21zM39 0H21c-3.315 0-6 2.685-6 6v6H6c-3.315 0-6 2.685-6 6v24c0 3.315 2.685 6 6 6h3a3.001 3.001 0 0 0 0-6c-1.656 0-3-1.344-3-3V21c0-1.656 1.344-3 3-3h42c1.656 0 3 1.344 3 3v18c0 1.656-1.344 3-3 3a3.001 3.001 0 0 0 0 6h3c3.315 0 6-2.685 6-6V12h-3V9a3.001 3.001 0 0 0-6 0v3h-6V6c0-3.315-2.685-6-6-6zm-9 28.5c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.78daadd0f1659fe7022695e5a271a9d7.svg";
export { ForwardRef as ReactComponent };